export const environment = {
  production: false,
  msalConfig: {
    clientId: '9f95dd2c-bd2e-4bea-8973-c8b0ab70a3c5',
    tenantId: '5520bf2a-e65c-4ca4-82c0-6169cccfd425',
    redirectUri: 'https://cxadmin-dev.12elementsconsulting.com',
    postLogoutRedirectUri: 'https://cxadmin-dev.12elementsconsulting.com/login',
  },
  apiScopes: ['user.read'],
  services: {
    apiBaseUrl: 'https://services-dev.deercreeklending.com',
  },
};
